import {IRootScopeService} from "angular";


export class LoaderStatusValue {
    private status: boolean;
    private $rootScope: IRootScopeService;

    constructor($rootScope: IRootScopeService) {
        this.status = true;
        this.$rootScope = $rootScope;
    }

    off = () => {
        this.status = false;
        this.$rootScope.$broadcast(LOADER_OFF);
    };

    on = () => {
        this.status = true;
        this.$rootScope.$broadcast(LOADER_ON);
    };

}

export const LoaderStatus = ['$rootScope', LoaderStatusValue];
export const LOADER_ON = "loader_on";
export const LOADER_OFF = "loader_off";